module.exports = __webpack_public_path__ + "img/operate8.67112f5f.png";